import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const shouldShowCyberWeek =
  dayjs.utc().isAfter(dayjs.utc('2025-11-26')) &&
  dayjs.utc().isBefore(dayjs.utc('2025-12-03'));

export const shouldShowChristmasTheme =
  dayjs.utc().isAfter(dayjs.utc('2025-12-03')) &&
  dayjs.utc().isBefore(dayjs.utc('2025-12-26'));

export const shouldShowBoxingDayTheme =
  dayjs.utc().isAfter(dayjs.utc('2025-12-26')) &&
  dayjs.utc().isBefore(dayjs.utc('2025-12-28'));

export const shouldShowHolidays =
  dayjs.utc().isAfter(dayjs.utc('2025-11-26')) &&
  dayjs.utc().isBefore(dayjs.utc('2025-12-28'));
